import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoor = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		opacity: .4,
		cx: 15,
		cy: 12,
		r: 2,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.5996 3C17.4393 3 17.8598 2.99981 18.1807 3.16309C18.4629 3.3069 18.6931 3.53709 18.8369 3.81934C19.0002 4.14015 19 4.56068 19 5.40039V18.5996C19 19.4393 19.0002 19.8598 18.8369 20.1807C18.6931 20.4629 18.4629 20.6931 18.1807 20.8369C17.8598 21.0002 17.4393 21 16.5996 21H7.40039C6.56068 21 6.14015 21.0002 5.81934 20.8369C5.53709 20.6931 5.3069 20.4629 5.16309 20.1807C4.99981 19.8598 5 19.4393 5 18.5996V5.40039C5 4.56068 4.99981 4.14015 5.16309 3.81934C5.3069 3.53709 5.53709 3.3069 5.81934 3.16309C6.14015 2.99981 6.56068 3 7.40039 3H16.5996ZM15 10C13.8954 10 13 10.8954 13 12C13 13.1046 13.8954 14 15 14C16.1046 14 17 13.1046 17 12C17 10.8954 16.1046 10 15 10Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgDoor);
export { ForwardRef as ReactComponent };
